module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-zh.f59fd846.mp4";